<template>
  <v-container fluid>
    <v-layout xs12 align-start row wrap>
      <v-flex xs12 sm12 md12 justify-center>
        <h2 class="ml-2 mb-2">{{ titulo }}</h2>
        <v-data-table
          :headers="headers"
          :items="$apollo.data.prices"
          :loading="$apollo.loading"
          item-key="id"
          class="elevation-1"
        >
          <template v-slot:top>
            <v-toolbar flat height="160">
              <div class="md8 mr-11 ml-2 row sm10 xs10">
                <v-flex xs12 sm12 md3 py-3>
                  <v-autocomplete
                    v-model="filters.id_drugstore"
                    v-bind:items="toArray(list_drugstores)"
                    id="id_drugstore"
                    label="Farmácia*"
                    item-text="name"
                    item-value="id"
                    :rules="rules"
                    required
                  >
                  </v-autocomplete>
                </v-flex>
                <v-flex xs12 sm12 md3 py-3>
                  <v-text-field
                    v-model="filters.product"
                    flat
                    hide-details
                    label="Produto"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md3 py-3>
                  <v-select
                    v-model="filters.issale"
                    :items="[
                      { text: 'Sim', value: true },
                      { text: 'Não', value: false }
                    ]"
                    item-text="text"
                    item-value="value"
                    id="issale"
                    label="Em promoção"
                  ></v-select>
                </v-flex>
              </div>
              <v-dialog v-model="dialog" max-width="500px">
                <template v-slot:activator="{ on }">
                  <v-btn
                    color="primary"
                    dark
                    class="mb-2"
                    v-on="on"
                    v-if="
                      user_role &&
                        (user_role.role == 'owner' || user_role.role == 'admin')
                    "
                    >Adicionar</v-btn
                  >
                </template>
                <v-card>
                  <v-card-title>
                    <span class="headline">{{ formTitle }}</span>
                  </v-card-title>

                  <v-card-text>
                    <v-container>
                      <v-form
                        ref="form"
                        v-model="valid"
                        :lazy-validation="lazy"
                      >
                        <v-row>
                          <v-autocomplete
                            v-model="editedItem.id_product"
                            v-bind:items="toArray(list_products)"
                            id="id_product"
                            label="Produto*"
                            item-text="name"
                            item-value="id"
                            :disabled="editedItem.id !== null ? true : false"
                            :rules="rules"
                            :filter="searchProduct"
                            cache-items
                            required
                          >
                            <template slot="selection" slot-scope="data">
                              {{ data.item.name }} / {{ data.item.ean1 }}
                            </template>
                            <template slot="item" slot-scope="data">
                              {{ data.item.name }} / {{ data.item.ean1 }}
                            </template>
                          </v-autocomplete>

                          <v-autocomplete
                            v-model="editedItem.id_drugstore"
                            v-bind:items="toArray(list_drugstores)"
                            :disabled="
                              user_role.role == 'owner' &&
                              user_role.drugstore_ids.length == 1
                                ? true
                                : false
                            "
                            id="id_drugstore"
                            label="Farmácia*"
                            item-text="name"
                            item-value="id"
                            :rules="rules"
                            required
                          >
                          </v-autocomplete>

                          <v-text-field
                            v-model.lazy="editedItem.cost"
                            id="cost"
                            label="Preço de compra"
                            :prefix="'R$'"
                            :rules="rulesMoney"
                          >
                          </v-text-field>

                          <v-text-field
                            v-model.lazy="editedItem.retail"
                            id="retail"
                            label="Preço de venda"
                            :prefix="'R$'"
                            :rules="rulesMoney"
                            required
                          >
                          </v-text-field>

                          <v-text-field
                            v-model="editedItem.storage"
                            id="storage"
                            label="Estoque"
                            :rules="rules"
                            required
                          >
                          </v-text-field>

                          <v-select
                            v-model="editedItem.issale"
                            :items="[
                              { text: 'Sim', value: true },
                              { text: 'Não', value: false }
                            ]"
                            item-text="text"
                            item-value="value"
                            id="issale"
                            label="Em promoção"
                          ></v-select>

                          <v-menu
                            v-if="editedItem.issale"
                            v-model="menu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                v-model="dateFormated"
                                label="Validade da Promoção"
                                readonly
                                @blur="
                                  editedItem.expiration = parseDate(
                                    dateFormated
                                  )
                                "
                                v-on="on"
                                required
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="editedItem.expiration"
                              @input="menu = false"
                            ></v-date-picker>
                          </v-menu>

                          <v-text-field
                            v-if="editedItem.issale"
                            v-model="editedItem.discount"
                            :prefix="'R$'"
                            id="discount"
                            label="Preço em Promoção"
                            :rules="rulesMoney"
                          >
                          </v-text-field>
                        </v-row>
                      </v-form>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <div class="flex-grow-1"></div>
                    <v-btn color="blue darken-1" text @click="close"
                      >Cancelar</v-btn
                    >
                    <v-btn color="blue darken-1" text @click="save"
                      >Salvar</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-toolbar>
          </template>
          <template v-slot:[`item.action`]="{ item }" style="width: 75px;">
            <div
              v-if="
                user_role &&
                  (user_role.role == 'owner' || user_role.role == 'admin')
              "
              style="cursor: pointer;width: 100px;"
              @click="editItem(item)"
            >
              <v-icon small class="mr-1">edit</v-icon>
            </div>
            <div
              v-if="user_role && user_role.role == 'admin'"
              style="cursor: pointer;width: 100px;"
              @click="deleteItem(item)"
            >
              <v-icon small class="mr-1">delete</v-icon>
            </div>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import {
  GetPrices,
  DeletePrices,
  InsertPrices,
  UpdatePrices
} from "../../graphql/prices.gql";
import { VMoney } from "v-money";
import VueJwtDecode from "vue-jwt-decode";
import gql from "graphql-tag";

let date = new Date();
export default {
  name: "prices-list",
  directives: { money: VMoney },
  data: vm => ({
    dialog: false,
    banner: false,
    valid: true,
    lazy: false,
    menu: false,
    user_role: [],
    list_products: [],
    list_drugstores: [],
    titulo: "Lista de Preços",
    dateFormated: vm.formatDate(
      new Date(date.getFullYear(), date.getMonth(), 1)
        .toISOString()
        .substr(0, 10)
    ),
    filters: {
      product: null,
      drugstore: null,
      issale: null,
      storage: null,
      cost: null,
      id_drugstore: null
    },
    headers: [
      { text: "Produto", value: "product.name" },
      { text: "Farmácia", value: "drugstore.name" },
      { text: "Preço", value: "cost" },
      { text: "Preço a varejo", value: "retail" },
      { text: "Ações", value: "action", sortable: false }
    ],
    editedIndex: -1,
    editedItem: {
      id: null,
      cost: "",
      retail: "",
      id_product: null,
      discount: 0.0,
      expiration: new Date(date.getFullYear(), date.getMonth(), 1)
        .toISOString()
        .substr(0, 10),
      issale: false,
      percent: null,
      enabled: true,
      id_drugstore: null,
      storage: 0,
      product: [],
      drugstore: []
    },
    defaultItem: {
      id: null,
      cost: "",
      retail: "",
      id_product: null,
      discount: 0.0,
      expiration: new Date(date.getFullYear(), date.getMonth(), 1)
        .toISOString()
        .substr(0, 10),
      issale: false,
      percent: null,
      enabled: true,
      id_drugstore: null,
      storage: 0,
      product: [],
      drugstore: []
    },
    rules: [v => !!v || "Campo obrigatório!"],
    rulesMoney: [
      //v => !!v && v.indexOf(',') < 0 || 'Valor inválido!. Ex: "1.5" ou "1".'
    ],
    money: {
      decimal: ".",
      thousands: "",
      prefix: "",
      suffix: "",
      precision: 2,
      masked: false
    }
  }),

  apollo: {
    prices: {
      query: GetPrices,
      variables() {
        return {
          product: this.filters.product
            ? { _ilike: "%" + this.filters.product + "%" }
            : {},
          id_drugstore: this.filters.id_drugstore
            ? { _eq: this.filters.id_drugstore }
            : {},
          issale: this.filters.issale ? { _eq: this.filters.issale } : {}
        };
      },
      skip() {
        return Object.values(this.filters).every(value => {
          if (value === null) {
            return true;
          }

          return false;
        });
      }
    }
  },

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nova Preço" : "Editar Preço";
    }
  },

  mounted: function() {
    //if(store.getters.token){
    if (localStorage.token) {
      this.user_role = VueJwtDecode.decode(localStorage.token);
    }

    //if(store.getters.token){
    if (localStorage.token) {
      this.user_role = VueJwtDecode.decode(localStorage.token);
    }

    this.$apollo
      .query({
        query: gql`
          query ListDrugstores {
            drugstores(where: { enabled: { _eq: true } }) {
              id
              name
              location
              description
              enabled
              hasdelivery
              address
            }
            products: products(order_by: { name: asc }) {
              id
              name
              ean1
              ean2
            }
          }
        `
      })
      .then(data => {
        if (data.data.drugstores) {
          this.list_drugstores = data.data.drugstores;
        }
        if (data.data.products) {
          this.list_products = data.data.products;
        }
      });
  },

  watch: {
    dialog(val) {
      val || this.close();
    },

    "editedItem.expiration": {
      deep: true,
      handler() {
        this.dateFormated = this.formatDate(this.editedItem.expiration);
      }
    },

    "filters.product": {
      deep: true,
      handler(val) {
        console.log(val);
        if (typeof val !== "undefined" && val !== null) {
          if (val.length == 0) {
            this.filters.product = null;
          }
        }
      }
    },

    "filters.id_drugstore": {
      deep: true,
      handler(val) {
        if (typeof val !== "undefined" && val !== null) {
          if (val.length == 0) {
            this.filters.id_drugstore = null;
          }
        }
      }
    }
  },

  methods: {
    searchProduct(item, queryText) {
      return (
        item.name.toLowerCase().indexOf(queryText) > -1 ||
        item.ean1.indexOf(queryText) > -1
      );
    },

    clear(value) {
      if (!value) {
        return null;
      }
    },

    editItem(item) {
      if (item.cost.length) item.cost = item.cost.replace(/\$/, "");
      if (item.cost.length) item.retail = item.retail.replace(/\$/, "");
      this.editedIndex = this.$apollo.data.prices.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      const index = this.$apollo.data.prices.indexOf(item);
      confirm("Deletar preço?") &&
        this.$apollo.data.prices.splice(index, 1) &&
        this.$apollo
          .mutate({
            mutation: DeletePrices,
            variables: {
              id: item.id
            }
          })
          .then(() => {
            this.$swal("Preço deletado com sucesso!", "", "success");
          })
          .catch(() => {
            this.$swal("Erro ao deletar preço!", "", "error");
          });
    },

    close() {
      this.dialog = false;
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedIndex = -1;
    },

    save() {
      let variables = {
        cost: this.editedItem.cost,
        id_product: this.editedItem.id_product,
        id_drugstore: this.editedItem.id_drugstore,
        retail: this.editedItem.retail,
        discount: this.editedItem.discount,
        percent: this.editedItem.percent,
        expiration: this.editedItem.expiration,
        issale: this.editedItem.issale,
        enabled: this.editedItem.enabled,
        storage: this.editedItem.storage
      };

      if (this.editedItem.id !== null) variables.id = this.editedItem.id;

      this.$apollo
        .mutate({
          // Query
          mutation: this.editedItem.id !== null ? UpdatePrices : InsertPrices,
          // Pass params dynamically
          variables: variables
        })
        .then(data => {
          if (this.editedItem.id !== null) {
            Object.assign(
              this.$apollo.data.prices[this.editedIndex],
              data.data.update_prices.returning[0]
            );
          } else {
            this.$apollo.data.prices.push(data.data.insert_prices.returning[0]);
          }
          this.close();
          this.$swal("Preço salvo com sucesso!", "", "success");
        })
        .catch(error => {
          console.log(error);
          this.close();
          this.$swal("Erro ao salvar o preço!", "", "error");
        });
    },

    toArray(array) {
      let items = [];
      array.forEach(v => items.push(v));
      return items;
    },

    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },

    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    }
  }
};
</script>

<style lang="stylus"></style>
